import styled from 'styled-components';

import Arrow from '../../images/Arrow_link_back.svg';
import variables from '../../styles/variables';

export const PrevPhaseButton = styled.button`
  font-size: 14px;
  font-weight: 600;
  height: 40px;
  color: ${variables.colorRed};
  text-decoration: none;
  display: flex;
  justify-self: start;
  align-items: center;
  margin-bottom: 0;
  border: none;
  background-color: ${variables.colorWhite};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  &:before {
    content: '';
    display: block;
    width: 10px;
    height: 8px;
    position: relative;
    right: 5px;
    background: url(${Arrow}) no-repeat scroll 0 0 transparent;
    background-position: center;
  }
  @media screen and (max-width: 768px) {
    grid-area: back;
  }
`;

// Phase wrappers
export const Data = styled.div`
  display: block;
  width: 100%;
`;

export const DeviceInfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  order: 2;
  padding: 0 15px;

  hr {
    width: 100%;
    margin-bottom: 0;
    height: 2px;
    background-color: #f3f3f3;
  }

  float: right;
  clear: right;

  @media screen and (max-width: 768px) {
    margin-top: 30px;
    float: none;
    clear: none;
  }
`;
